import { CustomTabsChild, CustomTabChild } from "../../styles/style";

const TabMenuFS = ({ tab, setTab }) => {
  const menuItems = [
    { value: "general", label: "General" },
    { value: "report_cfo", label: "CFO Report" },
    { value: "esg", label: "ESG" },
  ];

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  return (
    <CustomTabsChild value={tab} onChange={handleChange}>
      {menuItems.map((item) => (
        <CustomTabChild
          key={item.value}
          value={item.value}
          label={item.label}
          isSelected={tab === item.value}
        />
      ))}
    </CustomTabsChild>
  );
};

export default TabMenuFS;
